/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{VectorStack as e}from"../../core/VectorStack.js";const t=e.createVec2f64(),c=e.createVec3f64(),r=e.createVec4f64(),a=e.createMat3f64(),f=e.createMat4f64(),o=e.createQuatf64();export{a as sm3d,f as sm4d,o as sq4d,t as sv2d,c as sv3d,r as sv4d};
